import { Checkbox } from "@/components/ui/checkbox";
import { ValidationBadge, isFlagged } from "./validation";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const Tag = ({ ok, yes, no, testId }) => (
  <span data-testid={testId} className={`text-[11px] font-mono px-2 py-0.5 rounded-full border ${ok ? "bg-emerald-500/10 text-emerald-700 border-emerald-500/20" : "bg-amber-500/10 text-amber-700 border-amber-500/20"}`}>
    {ok ? yes : no}
  </span>
);

export function FinderResults({ results, sel, setSel, showCompany, vals = {} }) {
  const toggle = (e) => setSel((s) => (s.includes(e) ? s.filter((x) => x !== e) : [...s, e]));
  return (
    <div className="rounded-xl border border-border bg-card overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className="w-10" />{showCompany && <TableHead>Company</TableHead>}<TableHead>Email</TableHead><TableHead>Type</TableHead>
            <TableHead>Domain</TableHead><TableHead>Mail server</TableHead><TableHead>Validation</TableHead><TableHead>Found on</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {results.length === 0 && (
            <TableRow><TableCell colSpan={showCompany ? 8 : 7} className="text-center py-12 text-muted-foreground" data-testid="finder-empty">No published email addresses found. Try the company's exact domain.</TableCell></TableRow>
          )}
          {results.map((r) => (
            <TableRow key={r.email} data-testid={`finder-row-${r.email}`} className={`${r.in_project ? "opacity-60" : ""} ${isFlagged(vals[r.email]) ? "bg-rose-500/5 text-rose-700" : ""}`}>
              <TableCell>
                {r.in_project ? <span className="text-[10px] text-muted-foreground">added</span>
                  : <Checkbox checked={sel.includes(r.email)} onCheckedChange={() => toggle(r.email)} data-testid={`finder-select-${r.email}`} />}
              </TableCell>
              {showCompany && (
                <TableCell className="text-xs"><p className="font-medium">{r.company}</p><p className="text-muted-foreground font-mono">{r.domain}</p></TableCell>
              )}
              <TableCell className={`font-mono text-xs ${isFlagged(vals[r.email]) ? "text-rose-700 font-semibold" : ""}`} data-testid={`finder-email-${r.email}`}>{r.email}</TableCell>
              <TableCell className="text-xs">{r.role ? "Role / general" : "Personal"}</TableCell>
              <TableCell><Tag ok={r.on_domain} yes="company domain" no="other domain" /></TableCell>
              <TableCell><Tag ok={r.mx_ok} yes="accepts mail" no="no mail server" testId={`finder-mx-${r.email}`} /></TableCell>
              <TableCell><ValidationBadge v={vals[r.email]} testId={`finder-validation-${r.email}`} /></TableCell>
              <TableCell className="text-xs max-w-[280px]">
                {r.sources.map((s) => (
                  <a key={s} href={s} target="_blank" rel="noreferrer" className="block truncate text-indigo-700 hover:underline" title={s}>{s.replace(/^https?:\/\/(www\.)?/, "")}</a>
                ))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
